export default {
  Alimentação: 'FOOD',
  Lazer: 'LEISURE',
  Trabalho: 'WORK',
  Transporte: 'TRANSPORT',
  Saúde: 'HEALTH_CARE',
};
